import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enConfig from 'tdesign-vue/es/locale/en_US';

Vue.use(VueI18n);

export const LanguageOptions = [
  {
    /* i18n-ignore*/
    content: '简体中文',
    /* i18n-ignore*/
    label: '简体中文',
    value: 'zh-CN',
  },
  {
    content: 'English',
    label: 'English',
    value: 'en-US',
  },
];

const MessageObj = {
  'zh-CN': Object.assign({}, require('./zh-CN.json'), require('./private/zh-CN.json')),
  'en-US': Object.assign({}, require('./en-US.json'), require('./private/en-US.json'), enConfig),
  // zh: Object.assign({}, require('./zh'), require('@tencent/qcvue2/lib/locale/lang/zh-CN')),
  // en: Object.assign({}, require('./en'), require('@tencent/qcvue2/lib/locale/lang/en')),
};

const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识
  messages: MessageObj,
});

export default i18n;

export const i18n_t = (key: VueI18n.Path, values?: VueI18n.Values): string => {
  const tRes = i18n.t(key, values);
  // 返回值必须是字符串类型，不然项目中代码会报错
  if (typeof tRes !== 'string') throw { code: 'NeedReturnStringType' };
  return tRes;
};

// d 指 direct，根据locale的值直接返回对应语言的文本
export const i18n_td = (key: VueI18n.Path, locale: VueI18n.Locale, values?: VueI18n.Values): string => {
  const tRes = i18n.t(key, locale, values);
  // 返回值必须是字符串类型，不然项目中代码会报错
  if (typeof tRes !== 'string') throw { code: 'NeedReturnStringType' };
  return tRes;
};

export type LocalLanguageType = keyof typeof MessageObj;

export function IsLocalLanguageType(input: any): input is LocalLanguageType {
  return Object.keys(MessageObj).includes(input);
}

export type LanguageSettingParam = {
  language: LocalLanguageType;
};
